// extracted by mini-css-extract-plugin
export default {"AboutNav":"about_nav__AboutNav--qQrz","list":"about_nav__list--nqmg","link":"about_nav__link--6erS","linkActive":"about_nav__linkActive--M8LF"};